import { ApLoaderDefault, ApButtonMain } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding: 24px;
  background-color: #f1f1f1;
  min-height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const PageTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PageTitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 19px;
  line-height: 20px;
  color: #000000;
`;

export const PageSubtitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.87);
`;

export const ContentRow = styled.div`
  display: flex;
  gap: 24px;
  flex: 1;
`;

export const Aside = styled.aside`
  width: 240px;
  flex-shrink: 0;
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
`;

export const MainCard = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const MainCardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const MainCardTitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 17px;
  line-height: normal;
  color: #000000;
`;

export const DropZoneBox = styled.div<{ isDragActive?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 140px;
  border: 2px dashed
    ${({ isDragActive }) => (isDragActive ? '#498e2b' : '#cccccc')};
  border-radius: 4px;
  background-color: #ffffff;
  box-sizing: border-box;
`;

export const DropZoneTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: center;
  width: 100%;
`;

export const DropZonePrimary = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  color: #4a4a4a;
`;

export const DropZoneSecondary = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: normal;
  color: #727272;
`;

export const UploadedDocsHeading = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 17px;
  line-height: normal;
  color: #000000;
`;

export const ContinueToMappingButton = styled(ApButtonMain)`
  && {
    height: 32px;
    background-color: #498e2b;
  }
  &&:not([disabled]):hover,
  &&:not([disabled]):focus {
    background-color: #3f7b25;
  }
`;

export const UploadInput = styled.input``;

export const Loading = styled(ApLoaderDefault)`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const Error = styled.div`
  display: flex;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  justify-content: center;
  color: #cb282e;
`;
